import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { Select, SelectOption } from '../Select';
import { CityData } from '../../units/CityData';
import { FrontCategory } from '../../data/FrontCategory';

type FrontCategorySelectGroupProps = {
    frontCategoryList: FrontCategory[],
    selectedMainId: string,
    selectedSubId: string,
    onChange?: (mainId: string, subId: string) => void,
    disabled?: boolean,
};

FrontCategorySelectGroup.defaultProps = {
    onChange: () => {},
    disabled: false,
};

const useStyle = makeStyles((theme: Theme) => createStyles({
    root: {

    },
}));

function useMainOptions(frontCategoryList: FrontCategory[]) {
    const [mainOptions, setMainOptions] = useState<Array<SelectOption>>([]);
    useEffect(() => {
        setMainOptions(Object.values(frontCategoryList).map((item) => ({
            text: item.name,
            value: item.id.toString(),
        })));
    }, [JSON.stringify(frontCategoryList)]);

    return { mainOptions };
}

function useSubOptions(frontCategoryList: FrontCategory[], mainId: string) {
    const [subareaOptions, setSubareaOptions] = useState<Array<SelectOption>>([]);
    useEffect(() => {
        const selectMainCategory = frontCategoryList.find((item) => item.id.toString() === mainId.toString());
        if (selectMainCategory) {
            setSubareaOptions(selectMainCategory.list.map((item) => ({
                text: item.detail_name,
                value: item.detail_id.toString(),
            })));
        } else {
            setSubareaOptions([]);
        }
    }, [JSON.stringify(frontCategoryList), mainId]);

    return { subareaOptions };
}

function FrontCategorySelectGroup(props: FrontCategorySelectGroupProps): React.ReactElement {
    const {
        frontCategoryList,
        selectedMainId,
        selectedSubId,
        onChange = FrontCategorySelectGroup.defaultProps.onChange,
        disabled,
    } = props;
    const classes = useStyle();
    const { mainOptions } = useMainOptions(frontCategoryList);
    const { subareaOptions } = useSubOptions(frontCategoryList, selectedMainId);

    return (
        <>
            <Select
                labelId="input-main-select"
                label="問題主分類"
                options={mainOptions}
                value={Number(selectedMainId) || 'NULL'}
                placeholderOption={{ text: '請選擇主分類', value: 'NULL' }}
                onChange={(e) => onChange(e.target.value === 'NULL' ? '' : e.target.value as string, '')}
                disabled={disabled}
                variant={disabled ? 'filled' : 'outlined'}
            />
            <Select
                labelId="input-sub-select"
                label="問題次分類"
                options={subareaOptions}
                value={Number(selectedSubId) || 'NULL'}
                placeholderOption={{ text: '請選擇次分類', value: 'NULL' }}
                onChange={(e) => onChange(selectedMainId, e.target.value === 'NULL' ? '' : e.target.value as string)}
                disabled={disabled}
                variant={disabled ? 'filled' : 'outlined'}
            />
        </>
    );
}

export { FrontCategorySelectGroup };
